import { z } from "zod";
import { atom } from "jotai";

const QuestionEnum = z.enum(["Yes", "No", "Not Sure"]);

// Defined in backend by Maksym too - J
export const MockIncFormSchema = z.object({
  companyName: z.string(),
  website: z.string(),
  firstName: z.string(),
  lastName: z.string(),
  email: z.string().email(),
  phoneNumber: z.string(),
  country: z.string(), // TODO: maybe add list endpoint?
  companyDescription: z.string(),
  productDescription: z.string(),
  companyType: z.string(), // TODO -- get info about dropdown
  businessModel: z.string(), // TODO -- get info about dropdown
  focusArea: z.string(), // TODO -- get info about dropdown
  coreTechnology: z.string(),
  throughputRequired: z.string(),
  latencyRequired: z.string(),
  deviceForTesting: z.string(),
  simsForPoC: z.coerce.number(),
  sa5G: QuestionEnum,
  testWithDataSentric: QuestionEnum,
  externalCloud: QuestionEnum,
  teamSize: z.coerce.number(),
  technologyReadiness: z.string(),
  expectations: z.string(),
  superchargedAnswer: z.string(),
  buildAndTestAnswer: z.string(),
  getOutOfChallengeAnswer: z.string(),
  useCasePropositionAnswer: z.string(),
  deliverTheMostValueAnswer: z.string(),
  makesUniqueAnswer: z.string(),
  differentiatedAnswer: z.string(),
  importantFeaturesAnswer: z.string(),
  whereDidYouLearnAnswer: z.string(),
  files: z
    .array(
      z.object({
        filename: z.string(),
        base64: z.string(),
        filesize: z.string()
      })
    )
    .default([])
});

export type ApplicationForm = z.infer<typeof MockIncFormSchema>;

export const deutscheTelekomAtom = atom<ApplicationForm>({
  companyName: "",
  website: "",
  firstName: "",
  lastName: "",
  email: "",
  phoneNumber: "",
  country: "",
  companyDescription: "",
  productDescription: "",
  companyType: "",
  businessModel: "",
  focusArea: "",
  coreTechnology: "",
  throughputRequired: "",
  latencyRequired: "",
  deviceForTesting: "",
  simsForPoC: 0,
  sa5G: "Not Sure",
  testWithDataSentric: "Not Sure",
  externalCloud: "Not Sure",
  teamSize: 0,
  technologyReadiness: "",
  expectations: "",
  superchargedAnswer: "",
  buildAndTestAnswer: "",
  getOutOfChallengeAnswer: "",
  useCasePropositionAnswer: "",
  deliverTheMostValueAnswer: "",
  makesUniqueAnswer: "",
  differentiatedAnswer: "",
  importantFeaturesAnswer: "",
  whereDidYouLearnAnswer: "",
  files: []
});
